module.exports = __webpack_public_path__ + "img/Windows Administration.af2a2e75.png";